module.exports = __webpack_public_path__ + "static/media/galerija_2019 (32).1b3af512.jpg";